export interface IErrorHandler {
  code?: string;
  message?: string;
  entity?: string;
  column?: string;
  errorType?: string;
}

export interface IErrorResponse {
  message: string;
  isRecognized: boolean;
}

export const getError = (error: IErrorHandler): IErrorResponse => {
  // let message = translate(`error.unidentified`);
  let message = "Error indefinido";
  // if (error?.code) {
  //   switch (error.code) {
  //     case '23505': // UNIQUE
  //       /* eslint-disable-next-line */
  //       let messageArray = error.message.split('(');
  //       messageArray = messageArray[1].split(')');
  //       /* eslint-disable-next-line */
  //       const column = translate(`konectaFrontApp.${error.entity}.${error.column}`);
  //       /* eslint-disable-next-line */
  //       const entity = translate(`konectaFrontApp.${error.entity}.detail.title`);
  //       /* eslint-disable-next-line */
  //       message = translate(`error.unique`, { entity: entity, name: column });
  //       return {
  //         message,
  //         isRecognized: true,
  //       };

  //     default:
  //       if (error?.errorType && error?.entity) {
  //         message = translate(`konectaFrontApp.${error.entity}.errors.${error.errorType}`);
  //       } else if (error?.message !== '') {
  //         message = error.message;
  //       }
  //       return {
  //         message,
  //         isRecognized: true,
  //       };
  //   }
  // }
  // else {
  // CODE 0
  let isRecognized = false;
  if (error?.errorType && error?.entity) {
    // message = translate(`konectaFrontApp.${error.entity}.errors.${error.errorType}`);
    message = error?.message || "";
    isRecognized = true;
  } else if (error?.message !== "") {
    message = error?.message || "";
  }
  return {
    message,
    isRecognized,
  };
  // }
};
